import type { RouteRecordRaw } from 'vue-router'
import { INDEX_LAYOUT, INDEX_SEARCH_LAYOUT, PAGE_LAYOUT } from '@/router/constant'
// import Search from '@/views/search/index.vue'

/** 首页路由 */
const index: RouteRecordRaw = {
  path: '/index-page',
  name: 'index-page',
  component: PAGE_LAYOUT,
  children: [
    {
      path: '/index-layout',
      name: 'index-layout',
      component: INDEX_LAYOUT,
      redirect: '/index',
      children: [
        {
          path: '/index',
          name: 'index',
          meta: {
            title: '足球赛事',
            keepAlive: true,
          },
          component: () => import('@/views/index/index.vue'),
        },
        {
          path: '/detail/:matchId/:sportId',
          name: 'detail',
          meta: {
            title: '赛事详情',
            // keepAlive: true,
          },
          component: () => import('@/views/match/detail.vue'),
        },
      ],
    },
  ],
}

export default index
